import React, { useEffect, useState } from "react";

const AutoSuggestionBox = (props) => {
  const {
    SuggestionList,
    handleSelection,
    DivClassName,
    InputClassName,
    handleKeyPress,
    Ref,
    NextRef,
    InputId,
    Name,
    inputOnChangeFunction,
    InputLabel,
    AddNewButtonAllow,
    ShowName = "",
    SuggestionClass = "",
  } = props;

  const [inputName, setInputName] = useState("");
  const [ShowSuggestionBox, setShowSuggestionBox] = useState(false);

  useEffect(() => {
    ;
    console.log("SuggestionList", SuggestionList);
    console.log("InputId", InputId);

    if (InputId && SuggestionList.length > 0) {
      var data = SuggestionList.find((item) => item.id == InputId);
      if (data) {
        setInputName(data.name);
      } else {
        setInputName("not found");
      }
    }
  }, []);

  useEffect(() => {
    if (ShowName && ShowName.trim != "") {
      setInputName(ShowName);
    }
  }, [ShowName]);

  const setInputNameFunction = (e, data) => {
    if (!data) {
      setInputName(e.target.value);
      if (SuggestionList.length > 0) {
        setShowSuggestionBox(true);
      }
    } else {
      setInputName(data.name);
      setShowSuggestionBox(false);
    }
  };

  return (
    <div className={DivClassName} style={{ position: "relative" }}>
      <input
        className={InputClassName}
        ref={Ref}
        onKeyDown={(event) => handleKeyPress(event, NextRef)}
        type="text"
        autoComplete="off"
        name={Name}
        value={inputName}
        onChange={(e) => {
          inputOnChangeFunction(e);
          setInputNameFunction(e);
        }}
        required
      />
      <label className="modify_p_text2">{InputLabel}</label>

      {ShowSuggestionBox && (
        <ul
          className={
            SuggestionClass != ""
              ? SuggestionClass
              : "ItemmasterDuggestionsaleinvoice"
          }
          // ref={suggestionBoxRef}
          style={{ position: "absolute" }}
        >
          {SuggestionList.map((Data, index) => (
            <li
              key={index}
              onClick={(e) => {
                handleSelection(Data, index, Name);
                setInputNameFunction(e, Data);
              }}
            >
              {Data.name}
            </li>
          ))}
          {AddNewButtonAllow && (
            <li
              key={SuggestionList.length}
              className="addNew_btn_saleInvoice"
              style={{
                cursor: "pointer",
                borderBottom: "1px solid #ccc",
              }}
            >
              {" "}
              Add New
              <i class="fa-solid fa-plus"></i>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default AutoSuggestionBox;
